<template>
<!-- <v-container grid-list-md text-xs-center> -->
  <!-- <v-layout align-center justify-center row fill-height> -->
<v-flex xs12>  
  <v-layout align-center justify-center row fill-height>
  <material-card style="border: 5px solid #000; border-radius: 4px 10px 10px 10px; background-color: teal; box-shadow: 5px 5px 5px 3px rgba(0, 0, 0, 0.281);"
    v-bind="$attrs"
    class="v-card--material-stats pa-0 ma-0 comcard"
    v-on="$listeners"
    max-width="200"
    max-height="200"
    min-width="200"
    min-height="200"
    
    
  >
  <!-- Will be replaced by v-img -->
    <!-- <v-card
      slot="offset"
      :class="`elevation-${elevation}`"
      :color="color"
      class="pa-4"
      dark

    >
    
      <v-icon
        size="40"
      >
        {{ icon }}
      </v-icon>
    </v-card> -->
    <!-- <div class="text-xs-right" style="border: 6px solid #000;"> -->
    <div class="text-xs-right">
      <!-- Dropdown menu -->
      <v-menu v-if="subIconType == 'menu' || 'dropdown'">
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" color="white" size="45" class="" style=" border: 2px solid #000;border-radius: 60%; background-color: #000;">
            {{ subIcon }}
          </v-icon>
        </template>
        <v-list>
          <v-list-tile
            v-for="item in dropdown"
            :key="item['id']"
            @click="$emit(item.action)"
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      
      <v-icon v-else :color="subIconColor" size="30" class="">
        {{ subIcon }}
      </v-icon>
    </div>
    <div class="text-xs-center" style="height: 200;">
      <!-- <p
        class="category grey--text font-weight-light"
        v-text="title"
      /> -->
      <v-icon style="border: 4px solid #000; border-radius: 50%; background-color: white; width: 85px; height: 85px; position:absolute; top: 13%; left: 7px; box-shadow: 3px 3px 3px 1px rgba(0, 0, 0, 0.281);"
        color="teal"
        size="60"
        class="mr-0"
      >
        {{ bigIcon }}
      </v-icon>
      <h3
        class="title display-1 font-weight-light">
        {{ value }} <small>{{ smallValue }}</small>
      </h3>
    </div>
    
    <div style="position:absolute; bottom: 10px; left: 4.5%; border: 3px solid #000; min-width: 170px; max-width: 170px; border-radius:0 0px 6px 6px; background-color: #fff; color:red; padding-top:9px; box-shadow: inset 2px 2px 5px 2px rgba(0, 0, 0, 0.620)" slot="actions" class="pb-0 px-1 ma-0  text-xs-center">
      
      <p 
        :class="subTextColor+'--text'"
        class="font-weight-bold body-2 text-center black--text"
        >{{ subText }}</p>
    </div>
    
  </material-card>
  </v-layout>  
</v-flex>
<!-- </v-layout> -->
<!-- </v-container> -->
</template>

<script>
import Card from './Card'

export default {
  inheritAttrs: false,

  props: {
    ...Card.props,
    dropdown:{
      type: Array
    },
    subIcon: {
      type: String,
      default: undefined
    },
    bigIcon: {
      type: String,
      default: undefined
    },
    subIconType:{
      type: String,
      default: undefined
    },
    subIconColor: {
      type: String,
      default: undefined
    },
    bigIconColor:{
      type: String,
      default: undefined
    },
    subTextColor: {
      type: String,
      default: undefined
    },
    subText: {
      type: String,
      default: undefined
    },
    title: {
      type: String,
      default: undefined
    },
    value: {
      type: String,
      default: undefined
    },
    smallValue: {
      type: String,
      default: undefined
    }
  }
}
</script>

<style lang="scss">
.v-card--material-stats {
  display: flex;
  flex-wrap: wrap;
  position: relative;

  .v-offset {
    display: inline-block;
    flex: 0 1;
    margin-top: 0;
    margin-left: 0;
    margin-right: auto;
    margin-bottom: 0 !important;
    max-width: auto;
    padding: 0 16px 0;
  }

  .v-card {
    border-radius: 4px;
    flex: 0 1 auto;
  }

  .v-card__text {
    display: inline-block;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
  }

  .v-card__actions {
    flex: 1 0 100%;
  }
}

</style>

